import styles from "./styles.module.css";
import { useEffect, useState, useContext } from "react";
import { PageValue } from "../contexts/page";

export default function SelectElement({ action, onChange, block }) {
  const tree = useContext(PageValue);
  const [_blocks, setBlocks] = useState([]);
  useEffect(() => {
    if (tree && block) {
      const blocks = [];
      const getBlocks = (tree) => {
        if (tree.component === block) {
          blocks.push({ id: tree.id, name: tree.name });
        }
        tree.children.forEach((b) => {
          getBlocks(b);
        });
      };
      getBlocks(tree);
      console.log(blocks);
      setBlocks(blocks);
    }
  }, [tree, block]);

  const handleSave = (e) => {
    const _action = { ...action };
    _action.ref = e.target.value;
    onChange(_action);
  };
  return (
    <div className={styles.propInput}>
      <div className={styles.propTitle}>Select {block}</div>
      <select
        className={"dropdown"}
        onChange={handleSave}
        value={action.ref ? action.ref : ""}
      >
        <option disabled value=""></option>
        {_blocks.map((b) => {
          return (
            <option key={b.id} value={"ref" + b.id}>
              {b.name}
            </option>
          );
        })}
      </select>
    </div>
  );
}
